export default function ecAnimationService() {
  const flash = flashFactory();
  return { smartScroll, scrollTo, scrollIntoView, collapse, flash, moveUp, moveDown };
}

/*
 * smartScroll: Función de scroll para hacer visible un elemento
 *
 * - Si el elemento ya está completamente visible: no hacemos nada.
 * - Si está parcialmente visible: nos desplazamos hasta hacerlo completamente visible.
 * - Si es más grande que la vista: nos desplazamos hasta la parte superior de la pantalla.
 *
 * Opción offset: Corrección manual. Por ejemplo, para que sea visible un header.
 *
 */
function smartScroll(element, offset = 0) {
  const container = _getScrollParent(element);

  if (!container) {
    return;
  }

  const elHeight = element.offsetHeight + offset,
    elTop = element.offsetTop - offset,
    contHeight = container.offsetHeight,
    contTop = container.scrollTop,
    overflow = elTop + elHeight - (contTop + contHeight);

  // element no visible completamente
  if (overflow > 0) {
    // Si no cabe en la vista "scroll to top" sino "scroll into view"
    const scroll = elHeight > contHeight ? elTop : contTop + overflow;
    scrollTo(container, scroll);
  }
}

function _getScrollParent(element) {
  if (!element || !element.parentElement) {
    return null;
  }

  const parent = element.parentElement;
  return parent.scrollHeight > parent.clientHeight ? parent : _getScrollParent(parent);
}

function scrollTo(container, scrollTop, callback) {
  const goal = scrollTop - container.scrollTop,
    step = goal > 0 ? 100 : -100,
    LOOP_TIMER = 10;
  let steps = Math.floor(goal / step);
  if (!steps) {
    container.scrollTop = scrollTop;
    return typeof callback === 'function' ? callback() : true;
  }
  const timer = setInterval(scrollStep, LOOP_TIMER);

  function scrollStep() {
    container.scrollTop += step;
    if (!--steps) {
      clearInterval(timer);
      container.scrollTop = scrollTop;
      typeof callback === 'function' && window.requestAnimationFrame(callback);
    }
  }
}

// No soportado por Safari
const SCROLL_INTO_VIEW_OPTIONS = { behavior: 'smooth', block: 'nearest' };

function scrollIntoView(element) {
  if (!element || !element.scrollIntoView) {
    return;
  }

  element.scrollIntoView(SCROLL_INTO_VIEW_OPTIONS);
}

function moveUp(actual, moveTo) {
  actual.style.transform = `translateY(${moveTo.clientHeight}px)`;
  moveTo.style.transform = `translateY(-${actual.clientHeight}px)`;
  actual.style.MozTransform = `translateY(${moveTo.clientHeight}px)`;
  moveTo.style.MozTransform = `translateY(-${actual.clientHeight}px)`;
  actual.style.backgroundColor = 'white';
  moveTo.style.backgroundColor = 'white';
  actual.style.opacity = 0;

  window.requestAnimationFrame(() => {
    actual.style.transition = 'all 0.4s ease-in-out';
    moveTo.style.transition = 'all 0.4s ease-in-out';

    window.requestAnimationFrame(() => {
      actual.style.transform = '';
      moveTo.style.transform = '';
      actual.style.MozTransform = '';
      moveTo.style.MozTransform = '';
      actual.style.opacity = 1;
    });
  });
}

function moveDown(actual, moveTo) {
  actual.style.transform = `translateY(-${moveTo.clientHeight}px)`;
  moveTo.style.transform = `translateY(${actual.clientHeight}px)`;
  actual.style.MozTransform = `translateY(-${moveTo.clientHeight}px)`;
  moveTo.style.MozTransform = `translateY(${actual.clientHeight}px)`;
  actual.style.backgroundColor = 'white';
  moveTo.style.backgroundColor = 'white';
  actual.style.opacity = 0;

  window.requestAnimationFrame(() => {
    actual.style.transition = 'all 0.4s ease-in-out';
    moveTo.style.transition = 'all 0.4s ease-in-out';

    window.requestAnimationFrame(() => {
      actual.style.transform = '';
      moveTo.style.transform = '';
      actual.style.MozTransform = '';
      moveTo.style.MozTransform = '';
      actual.style.opacity = 1;
    });
  });
}

function collapse(elem, callback, options = {}) {
  if (!elem) {
    return 'elem mandatory';
  }
  if (typeof callback !== 'function') {
    callback = false;
  }
  let response = '';
  const ANIMATION_SECOND = options.duration || 0.3,
    styles = window.getComputedStyle(elem),
    isOpen = typeof options.force === 'boolean' ? options.force : elem.getBoundingClientRect().height;
  //
  return isOpen ? close() : open();

  function close() {
    response = 'closed';
    elem.style.maxHeight = styles.height;
    toState(
      _ => (elem.style.maxHeight = '0px'),
      () => callback && callback()
    );
    return 'closing';
  }

  function open() {
    response = 'opened';
    const height = getHeightFromClosed();
    elem.style.height = 'auto';
    elem.style.maxHeight = '0px';
    // toState(_=> elem.style.maxHeight = null )
    toState(
      () => {
        elem.style.maxHeight = `${height}px`;
      },
      () => {
        elem.style.maxHeight = null;
        callback && callback();
      }
    );
    return 'opening';
  }

  function toState(endStateFn, callback) {
    const ANIMATION_TIMEOUT = ANIMATION_SECOND * 1000;
    elem.style.transition = 'max-height ease-in-out';
    elem.style.transitionDuration = `${ANIMATION_SECOND}s`;
    window.requestAnimationFrame(_ => {
      window.requestAnimationFrame(_ => {
        endStateFn();
        setTimeout(_ => {
          elem.style.transition = styles.transition;
          elem.style.transitionDuration = styles.transitionDuration;
          // elem.style.maxHeight = null
          callback && callback(response);
        }, ANIMATION_TIMEOUT);
      });
    });
  }

  function getHeightFromClosed() {
    elem.style.height = 'auto';
    elem.style.maxHeight = 'none';
    const height = elem.getBoundingClientRect().height;
    elem.style.maxHeight = '0px';
    return height;
  }
}

function flashFactory() {
  const ANIMATION_TRANSITION = 'background-color .3s ease-in-out';
  const ANIMATION_BACKGROUND_COLOR = '#999'; // @odeniel el color de flash no puede ser como el selected que sino no se va ver (en el grid por ejemplo)
  const ANIMATION_TIMEOUT = 400; // @odeniel el color de flash no puede ser como el selected que sino no se va ver (en el grid por ejemplo)
  // para guardar los elementos animados
  const wm = new WeakMap();
  const wmCancel = new WeakMap();

  return function flash(elem, callback) {
    if (wm.has(elem)) {
      const cancel = wmCancel.get(elem);
      if (!cancel) {
        return;
      } // salimos
      // cancel de la animation para volver a empezarla
      clearTimeout(cancel);
      wmCancel.delete(elem);
    } else {
      const { transition, backgroundColor } = window.getComputedStyle(elem);
      wmCancel.delete(elem);
      wm.set(elem, { transition, backgroundColor });
    }

    window.requestAnimationFrame(() => {
      elem.style.transition = ANIMATION_TRANSITION;
      elem.style.backgroundColor = ANIMATION_BACKGROUND_COLOR;

      wmCancel.set(
        elem,
        setTimeout(
          () =>
            window.requestAnimationFrame(() => {
              const { transition, backgroundColor } = wm.get(elem);
              // restaurar backgroundColor original
              elem.style.backgroundColor = backgroundColor;

              wmCancel.set(
                elem,
                setTimeout(() => {
                  // restaurar transition original
                  elem.style.transition = transition;
                  // limpiamos los WeakMap
                  window.requestAnimationFrame(() => {
                    wm.delete(elem);
                    wmCancel.delete(elem);
                  });
                  callback && callback();
                }, ANIMATION_TIMEOUT)
              );
            }),
          ANIMATION_TIMEOUT
        )
      );
    });
  };
}
